<template>
  <div class="container-sm">
<!--    <div class="mb-2 text-secondary ml-3"> 帮助中心 </div>-->
    <div class="row" v-if="$store.state.user.check_is_wxc_domain()">
      <div class="col-sm-3 left-top-nav pb-3 pt-0 maincontent0">
        <div @click="menuId=100" class="left-nav-item d-flex justify-content-between"
             :style="menuId===100?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何上文学城首页
          </div>
        </div>
        <div class="title"><div class="mt-1"><h3 class="text-muted mb-3">群主相关</h3></div></div>
        <div @click="menuId=0" class="left-nav-item d-flex justify-content-between"  :style="menuId===0?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何创建群吧
          </div>
        </div>
        <div @click="menuId=1" class="left-nav-item d-flex justify-content-between"
             :style="menuId===1?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何管理群吧
          </div>
        </div>
        <div @click="menuId=11" class="left-nav-item d-flex justify-content-between"
             :style="menuId===11?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            <span class="float-left">如何设置推广</span><div class="New-titleTip">New</div>
          </div>
        </div>
        <div @click="menuId=2" class="left-nav-item d-flex justify-content-between"
             :style="menuId===2?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何邀请群员
          </div>
        </div>
        <div @click="menuId=7" class="left-nav-item d-flex justify-content-between"
             :style="menuId===7?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何管理群员
          </div>
        </div>
        <div @click="menuId=9" class="left-nav-item d-flex justify-content-between"
             :style="menuId===9?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何批准群员
          </div>
        </div>
        <div @click="menuId=3" class="left-nav-item d-flex justify-content-between"
             :style="menuId===3?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
             <span class="float-left">如何创建话题</span><div class="New-titleTip">New</div>
          </div>
        </div>
        <div @click="menuId=12" class="left-nav-item d-flex justify-content-between"
             :style="menuId===12?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            <span class="float-left">话题管理帖子</span><div class="New-titleTip">New</div>
          </div>
        </div>
        <div class="title"><div class="mt-1"><h3 class="text-muted mb-3">常见问题</h3></div></div>
        <div @click="menuId=4" class="left-nav-item d-flex justify-content-between"
             :style="menuId===4?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何加入群吧
          </div>
        </div>
        <div @click="menuId=5" class="left-nav-item d-flex justify-content-between"
             :style="menuId===5?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何退出群吧
          </div>
        </div>
      </div>
      <div class="col-sm-9 col-12 pb-4 maincontent0">
        <div class="title">
          <div class="info">
            <h3>群吧 帮助中心</h3>
          </div>
        </div>
        <div v-if="menuId===0">
          <h5 class="border-bottom py-3 pl-3">如何创建群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：页面左侧"新建群吧" 按钮</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1点击"新建群吧"</span>
              </div>
              <div>
                <span>2.选择群吧分类</span>
              </div>
              <div>
                <span>3.在弹框内填写群吧名称和群吧主题</span>
              </div>
              <div class="mb-3">
                <span>4.确认群吧类型，为了保护群吧成员的隐私 <br>
                  <span class="font-weight ml-3">
                    <i style="color:#fea50b;" class="el-icon-message-solid"></i>公开或非公开，设定后不可更改</span></span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-4">
                <img src="/img/create_group.webp" class="logo">
              </div>
            </div>
          </div>
        </div>
        <div v-if="menuId===1">
          <h5 class="border-bottom py-3 pl-3">如何管理群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：群吧名右侧"管理"  <i size="medium" class="el-icon-s-tools"></i>icon</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>点击
                  <span class=" group-rule">
                    <i size="medium" class="el-icon-s-tools"></i>
                    <span style="margin-left: 0px;">弹出下拉菜单</span>
                  </span>
                </span>
              </div>
              <div>
                <span>下拉菜单可操作</span>
              </div>
              <div>
                <span class="mb-3 d-block">  <i class="el-icon-edit"></i>修改群吧名</span>
                <span class="mb-3 d-block">  <i class="el-icon-tickets"></i>修改群吧主题</span>
                <span class="mb-3 d-block">  <i class="el-icon-delete"></i>删除群吧</span>
              </div>
              <div>
                <span class="mb-3 d-block"> 点击群吧头像 <i class="el-icon-camera"></i>icon 可更换群吧头像</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/manage_group.webp" class="logo">
              </div>
            </div>
          </div>
        </div>
        <div v-if="menuId===7">
          <h5 class="border-bottom py-3 pl-3">如何管理群员</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：群吧顶部群员头像</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1.点击"群员头像"</span>
              </div>
              <div>
                <span>2.点击"群员头像"右侧<i size="medium ml-2" class="el-icon-more"></i>icon</span>
              </div>
              <div>
                  <span class="ml-3"><i size="medium" class="el-icon-user"></i>设置/撤销群员为管理员</span>
              </div>
              <div class="mb-3">
                   <span class="ml-3"><i size="medium" class="el-icon-delete"></i>删除群员</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/manage_members.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===9">
          <h5 class="border-bottom py-3 pl-3">如何批准群员</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="my-2">
                <span>位置：群吧顶部群员头像</span>
              </div>
              <span>如果有用户申请您的群吧，您的群吧顶部会出现申请人数</span>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>点击"群员头像/或申请人提示"</span>
              </div>
              <div>
                <span class="ml-3">点击批准<i class="el-icon-check"></i>允许新群员加入</span>
              </div>
              <div class="mb-3">
                <span class="ml-3">点击拒绝<i class="el-icon-close" style="color: rgb(220, 53, 69);"></i>拒绝此人成为群员</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/approve_mumber.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===2">
          <h5 class="border-bottom py-3 pl-3">如何邀请群员</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：群吧顶部群员头像</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1.点击"群员头像"</span>
              </div>
              <div>
                <span>2.点击"查找邀请群员"搜索框</span>
              </div>
              <div>
                <span>3.输入想要邀请的群员</span>
              </div>
              <div>
                <span>4.在列表中选中此群员，点击"邀请"</span>
              </div>
              <div class="mb-3">
                <span>此群员即出现在群吧列表中</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/invite_members.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===3">
          <h5 class="border-bottom py-3 pl-3">如何创建话题</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="my-2">
<!--              <div><i class="el-icon-user"></i><span>群主和管理员可以使用话题来管理群内容</span></div>-->
              <div class="mt-2">
                <span>位置：页面左侧 您创建的群吧下面 "添加话题" 输入框</span>
              </div>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>1. <span>"添加话题"中输入您想要创建的话题，点击 <i
                  class="el-icon-check text-success"></i>#话题就创建好了。  </span></div>
              <div>
                <div><i class="el-icon-folder"></i><span>在此#话题下发出的帖子都从属于此#话题，并会带上此#话题标签</span></div>
                <div><span>#话题下发的帖子除了本话题同时也会出现在<i class="el-icon-s-comment ml-2 mr-0 green"></i>讨论</span></div>
              </div>
<!--              <div><i class="el-icon-magic-stick"></i><span>让群员更轻松地发现相关类别话题的帖子</span></div>-->

              <div class="col-12 pt-4 col-md-12 ml-0 mt-4"><img src="/img/group_topic.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===4">
          <h5 class="border-bottom py-3 pl-3">如何加入群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：发现群吧-"加入"按钮。 群吧顶部右侧"加入"按钮。</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>点击"加入"按钮加入群吧</span>
              </div>
              <div>
                <span>公开群吧无需加入 发表评论即可成为群员</span>
              </div>
              <div class="mb-3">
                <span>非公开群吧，点击后，待群主批准，即可加入</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/join_group.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===5">
          <h5 class="border-bottom py-3 pl-3">如何退出群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：群吧顶部群员头像</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1.点击"群员头像"</span>
              </div>
              <div>
                <span>2.点击底部 <i class="el-icon-switch-button"></i>退出群吧</span>
              </div>
              <div class="mb-3">
                <span>退出群吧完成</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/exit_group.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===11">
          <h5 class="border-bottom py-3 pl-3">如何设置推广置顶贴</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
              <span>设置推广置顶贴，让您群里的好帖子被更多人看见</span><br>
<!--              <span>公开/非公开群吧的首页推广置顶贴，除了该群首页也会出现在<i class="el-icon-document-copy medium"></i></span>-->
<!--                <span class="pl-2">推广帖子</span>-->
              </div>
              <div class="mt-4">
                <span>位置：帖子标题右侧icon <i size="medium" class="el-icon-more trans ml-2"></i> </span>
              </div>
              <div>
                <span>操作：</span>
              </div>
               <div>
                <span>1. 点击 <i size="medium" class="el-icon-more trans ml-2"></i> </span>
                </div>
                <div>
                  <span>2. 点击下拉菜单里的"推至/撤下首页推广置顶贴", 帖子即会被推至/撤下首页</span>
                </div>


              <div class="mb-3">

                <div><i class="el-icon-bell medium"></i>
                  <span class="mb-4">公开/非公开群的"推广置顶贴"，除了该群首页<br>
                  </span>
                  <span class="ml-3">同时会出现在，文学城首页。</span>
                  <span class="">以及群吧左侧</span><i class="el-icon-document-copy medium "></i>
                  <span>"推广置顶"列表 </span><span class="ml-4 pl-3"></span>
                </div>


<!--                2 文学城首页（此功能即将推出）-->


              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/recommendwxc.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===12">
          <h5 class="border-bottom py-3 pl-3">话题管理帖子</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：帖子标题右侧<i size="medium" class="el-icon-more trans ml-2"></i>icon </span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>需先在<i class="el-icon-s-comment ml-2 mr-0 green"></i>讨论下方点击“添加话题”输入您想要添加的话题 具体参考<a href="https://groups.wenxuecity.com/help/?id=3">如何创建话题</a></span>
              </div>
              <div>
                <span>1.点击帖子标题右侧<i size="medium" class="el-icon-more trans ml-2"></i> 点击弹框下拉菜单里的"#话题管理"</span>
              </div>
              <div class="mb-3">
                <span>2.把帖子按您的需要放在/转移到您已经建好的话题里</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/group_topic.png" class="logo">
              </div>
            </div>

          </div>
        </div>

        <div v-if="menuId===100">
          <h5 class="border-bottom py-3 pl-3">如何上文学城首页</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>各群吧的<a  target="_blank" href="https://groups.wenxuecity.com/help/?id=11"> 置顶推广贴</a> 会出现在文学城首页 "群吧置顶" 左侧。<br>
                   <span class="mt-3">最新推广的帖子出现在最顶部，编辑有权根据帖子质量调整。 </span>
                   <img style="width: 460px;margin: 0 auto;display: block"  src="/img/wxc_left.webp" class="logo mt-3">
                </span>
              </div>
              <div>
                <span>公开/非公开群，历年点击数最高的帖子的依次出现在右侧</span>
                <img style="width: 460px;margin: 0 auto;display: block"  src="/img/wxc_right.webp" class="logo mt-3">
              </div>
<!--              <div class="mb-3">-->
<!--                <i class="el-icon-bell medium"></i>-->
<!--                <span>同一个群组的帖子，只会-->
<!--                  "群吧置顶"左侧出现一次-->
<!--                </span>-->
<!--              </div>-->

            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-sm-3 left-top-nav pb-3">
<!--        <div @click="menuId=100" class="left-nav-item d-flex justify-content-between"-->
<!--             :style="menuId===5?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">-->
<!--          <div class="name">-->
<!--            文学城群吧相关问题-->
<!--          </div>-->
<!--        </div>-->
        <div @click="menuId=0" class="left-nav-item d-flex justify-content-between"  :style="menuId===0?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何创建群吧
          </div>
        </div>
        <div @click="menuId=1" class="left-nav-item d-flex justify-content-between"
             :style="menuId===1?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何管理群吧
          </div>
        </div>
        <div @click="menuId=2" class="left-nav-item d-flex justify-content-between"
             :style="menuId===2?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何邀请群员
          </div>
        </div>
        <div @click="menuId=3" class="left-nav-item d-flex justify-content-between"
             :style="menuId===3?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何使用话题
          </div>
        </div>
        <div @click="menuId=4" class="left-nav-item d-flex justify-content-between"
             :style="menuId===4?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何加入群吧
          </div>
        </div>
        <div @click="menuId=5" class="left-nav-item d-flex justify-content-between"
             :style="menuId===5?{color:'#44753d', fill: '#44753d', background: 'aliceblue'}:''">
          <div class="name">
            如何退出群吧
          </div>
        </div>
      </div>
      <div class="col-sm-9 col-12 pb-4">
        <div v-if="menuId===0">
          <h5 class="border-bottom py-3 pl-3">如何创建群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：页面左侧"新建群吧" 按钮</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1点击"新建群吧"</span>
              </div>
              <div>
                <span>2.选择群吧分类</span>
              </div>
              <div>
                <span>3.在弹框内填写群吧名称和群吧主题</span>
              </div>
              <div class="mb-3">
                <span>3.确认群吧类型，为了保护群吧成员的隐私<span class="font-weight">公开或非公开，设定后不可更改</span></span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/create_group_hai.webp" class="logo">
              </div>
            </div>
          </div>
        </div>
        <div v-if="menuId===1">
          <h5 class="border-bottom py-3 pl-3">如何管理群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：群吧名右侧"管理"  <i size="medium" class="el-icon-s-tools"></i>icon</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1.点击
                  <span class=" group-rule">
                    <i size="medium" class="el-icon-s-tools"></i>
                    <span style="margin-left: 0px;">管理</span>
                  </span>
                </span>
              </div>
              <div>
                <span>2.在弹框内填写群吧名称和群吧主题</span>
              </div>
              <div class="mb-3">
                <span>3.确认群吧类型，为了保护群吧成员的隐私 <br>
                  <span class="font-weight ml-3"><i style="colo:#eee" class="el-icon-bell"></i>公开或非公开，设定后不可更改</span></span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-3"><img src="/img/manage_group_hai.webp" class="logo">
              </div>
            </div>
          </div>
        </div>
        <div v-if="menuId===2">
          <h5 class="border-bottom py-3 pl-3">如何邀请群员</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：群吧顶部群员头像</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1.点击"群员头像"</span>
              </div>
              <div>
                <span>2.点击"查找邀请群员"搜索框</span>
              </div>
              <div>
                <span>3.输入想要邀请的群员</span>
              </div>
              <div>
                <span>4.在列表中选中此群员，点击"邀请"</span>
              </div>
              <div>
                <span>此群员即出现在群吧列表中</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/invite_members_hai.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div  v-if="menuId===3">
          <h5 class="border-bottom py-3 pl-3">如何创建话题</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="my-2">
                <!--              <div><i class="el-icon-user"></i><span>群主和管理员可以使用话题来管理群内容</span></div>-->
                <div class="mt-2">
                  <span>位置：页面左侧 您创建的群吧下面 "添加话题" 输入框</span>
                </div>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>1. <span>"添加话题"中输入您想要创建的话题，点击 <i
                  class="el-icon-check text-success"></i>#话题就创建好了。  </span></div>
              <div>
                <div><i class="el-icon-folder"></i><span>在此#话题下发出的帖子都从属于此#话题，并会带上此#话题标签</span></div>
                <div><span>#话题下发的帖子除了本话题同时也会出现在<i class="el-icon-s-comment ml-2 mr-0 green"></i>讨论</span></div>
              </div>
              <!--              <div><i class="el-icon-magic-stick"></i><span>让群员更轻松地发现相关类别话题的帖子</span></div>-->

              <div class="col-12 pt-4 col-md-12 ml-0 mt-4"><img src="/img/group_topic_hai.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===4">
          <h5 class="border-bottom py-3 pl-3">如何加入群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：发现群吧-"加入"按钮。 群吧顶部右侧"加入"按钮。</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>点击"加入"按钮加入群吧</span>
              </div>
              <div>
                <span>公开群吧无需加入 发表评论即可成为群员</span>
              </div>
              <div>
                <span>非公开群吧，点击后，待群主批准，即可加入</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/join_group_hai.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===5">
          <h5 class="border-bottom py-3 pl-3">如何退出群吧</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>位置：群吧顶部群员头像</span>
              </div>
              <div>
                <span>操作：</span>
              </div>
              <div>
                <span>1.点击"群员头像"</span>
              </div>
              <div>
                <span>2.点击底部 <i class="el-icon-switch-button"></i>退出群吧</span>
              </div>
              <div>
                <span>退出群吧完成</span>
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0"><img src="/img/exit_group.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
        <div v-if="menuId===100">
          <h5 class="border-bottom py-3 pl-3">文学城群吧相关问题</h5>
          <div class="blog-user-index">
            <div class="recommend  bg-content mt-0">
              <div class="mt-2">
                <span>文学城群吧改名为文学城群吧</span>
              </div>
              <div>
                <span>具体操作请参看左侧各项详情</span>
              </div>

              <div class="col-12 pt-4 col-md-12 ml-0 mt-0">
                <img src="/img/create_group.webp" class="logo">
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0">
                <img src="/img/manage_group.webp" class="logo">
              </div>
              <div class="col-12 pt-4 col-md-12 ml-0 mt-0">
                <img src="/img/invite_members.webp" class="logo">
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import account from '@/module/user/user.service';

export default {
  name: 'help',
  components: {
  },
  created(){
    this.menuId = Number(this.$route.query.id);
  },
  computed:{
    isCns(){
      return localStorage.lang==='cns'
    }
  },
  data(){
    return{
      menuId:1,
    }
  },

};
</script>
<style>
.recommend {
  margin-bottom: 10px;
}

.recommend span {
  color: #6c757d;
}

.recommend div {
  margin-top: 24px;
}

.recommend div i {
  margin-right: 10px;
  font-size: 26px;
  color: #78838d;
  vertical-align: top;
}

.recommend div span {
  font-size: 18px;
}

.blacklist {
  padding: 12px 18px
}
.collection-box {
  background-color: #fbfbfb;
  border-radius: 16px;
  padding: 18px 0;
}
.left-nav-item {
  padding: 12px 18px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  color:#5b7083
}
.left-nav-item .name {
  font-size: 1.2rem;
  font-weight: 600;

}
.left-nav-item:hover{
  color: #44753d;
  fill: #44753d
}

.userset-t {
  padding: 10px 0 0;
}
.blacklist {
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
}
.user-bg {
  background-size: cover;
  background-position-y: center;
}
.user-bgup {
  height: 100px;
}
.country .el-input__inner{
  border-radius: 16px;
}
.maincontent0 .title {
  /*background: url(https://blog.wenxuecity.com/images/title_shadow_340x10.gif) no-repeat bottom center;*/
  padding-top: 0;
}
.maincontent0 .title .info {
  background: url(https://blog.wenxuecity.com/images/bg_title.gif) repeat-x;
  /*border: 1px solid #ccc;*/
  border-top: none;
  height: 40px;
  line-height: 40px;
  padding-left: 16px;
}
.maincontent0 .title h3 {
  /*background: url(https://blog.wenxuecity.com/images/bg_arrow_down.gif) no-repeat top left 32px;*/
  color: #505050;
  display: block;
  font-size: 18px;
  padding-top: 8px;
  font-weight: bold;
}
.New-titleTip {
  margin-left: 16px;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  float: left;
  background: linear-gradient(90.55deg,rgba(103,194,58,.1) .48%,rgba(103,194,58,.03) 99.52%);
  color: #67c23a;
}
#WxcColor .el-icon-more.trans, #WxcColor .btn-info.btn-link {
  color: #4d8146!important;
  border: 2px solid #4d8146;

}
.green{
  color: #4d8146!important;
}
#WxcColor .el-icon-more.trans {
  font-weight: 800;
  font-size: 13px;
  border-radius: 50px;
  padding: 4px;
  margin-top: 0;
  vertical-align: text-bottom;
  -webkit-transform: rotate(90deg);
}
</style>
